export default (country, language) => {
  switch (country.toLowerCase()) {
    case 'tw':
    case 'hk':
      return 'JhengHei'; // Traditional chinese caught by country

    case 'jp':
      return 'Meiryo';
    default:
      break;
  }

  switch (language.toLowerCase()) {
    case 'ar':
    case 'he':
    case 'th':
      return 'Tahoma';

    case 'zh':
      return 'YaHei'; // Simplified Chinese for rest of zh

    case 'ko':
      return 'Malgun';

    case 'ta':
      return 'Latha';

    default:
      break;
  }
  return 'Noto IKEA';
};
